import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
} from "@mui/material";

const PruningTable = ({ data, searchTerm }) => {
  let filteredPlants = data;
  if (searchTerm) {
    filteredPlants = data.filter((plant) => {
      return plant.name.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }
  return (
    <TableContainer
      component={Paper}
      style={{
        maxWidth: "40rem",
      }}
    >
      <Table>
        <TableHead>
          <TableRow
            style={{
              backgroundColor: "#f5f5f5",
            }}
          >
            <TableCell>Plant Name</TableCell>
            <TableCell>Pruning</TableCell>
            <TableCell>Prune Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredPlants.map((plant) => (
            <TableRow key={plant.name}>
              <TableCell
                style={{
                  display: "flex",
                  //   alignItems: "center",
                  flexDirection: "column",
                  //   // space between
                  justifyContent: "space-between",
                }}
              >
                <Avatar
                  alt={plant.name}
                  src={plant.image}
                  sx={{ width: 24, height: 24 }}
                />
                {plant.name}
              </TableCell>
              <TableCell>{plant.pruningMethod}</TableCell>
              <TableCell>{plant.pruneTime}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PruningTable;
